import React from "react";
import styled from "styled-components";

const ContactContainer = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  font-family: "Arial", sans-serif;
  color: white; /* Set text color to white for visibility */
`;

const Heading = styled.h1`
  font-size: 2.5em;
  margin-bottom: 20px;
`;

const Paragraph = styled.p`
  line-height: 1.6;
  margin-bottom: 15px;
`;

const ContactButton = styled.a`
  display: inline-block;
  padding: 10px 20px;
  font-size: 14px;
  color: #f2f2f2;
  background: #444;
  border-radius: 30px;
  text-decoration: none;
  text-align: center;
  font-weight: bold;
  transition: background 0.3s ease, color 0.3s ease;
  margin-top: 20px;

  &:hover {
    background: #f2f2f2;
    color: #262626;
  }

  &::after {
    content: " →";
  }

  @media (max-width: 768px) {
    width: 40%; /* Full width on mobile */
    padding: 10px 0; /* Adjust padding for centered content */
    border-radius: 20px; /* Slightly less rounded on full width */
  }
`;

function Contact() {
  return (
    <ContactContainer>
      <Heading>Say hi!</Heading>
      <Paragraph>
        I'm available for freelance and contract roles. I also enjoy
        collaborating with like-minded people equally energized by the potential of emerging
        technologies to rethink how we can experience ourselves and one another in meaningful ways. If this is you,
        you have a bright idea, and are in search of a partner in crime, I would love to
        connect with you too.
      </Paragraph>
      <ContactButton href="mailto:majj.johnson@gmail.com">
        Contact Marcha
      </ContactButton>
    </ContactContainer>
  );
}

export default Contact;
